/* eslint-disable camelcase */
import Model from '@/entities/Model.js';

export default class CustomerEmail extends Model {
    static get defaults() {
        return {};
    }
}
